import { BaseService } from "./BaseService";

export const UnidadeExecutoraService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('unidade-executora/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos unidade executoras:', error);
            return false;
        }
    },
    async store(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('unidade-executora', postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a criação de unidade executoras:', error);
            return false;
        }
    },
    async select(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIGet('unidade-executora/select', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos unidades executoras:', error);
            return false;
        }
    },
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`unidade-executora/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca de unidade executoras:', error);
            return false;
        }
    }, 
    async update(id, postData) {
        try {
            postData.append("_method", "PUT");
            return await BaseService.fetchResponseFromAPIPost(`unidade-executora/${id}`, postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a atualização de unidade executoras:', error);
            return false;
        }
    }, 
    async destroy(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('unidade-executora/destroy', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao excluir unidade executoras:', error);
            return false;
        }
    }, 
    async activate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('unidade-executora/activate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao ativar unidade executoras:', error);
            return false;
        }
    }, 
    async deactivate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('unidade-executora/deactivate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao desativar unidade executoras:', error);
            return false;
        }
    }, 
    async selectWithExercicio(exercicio) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`unidade-executora/select/${exercicio}`);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos unidades executoras:', error);
            return false;
        }
    },
}